import { useMemo } from "react";

export interface DatePickerStrings {
  months: string[];
  shortMonths: string[];
  days: string[];
  shortDays: string[];
  goToToday: string;
  prevMonthAriaLabel: string;
  nextMonthAriaLabel: string;
  prevYearAriaLabel: string;
  nextYearAriaLabel: string;
  closeButtonAriaLabel: string;
  monthPickerHeaderAriaLabel: string;
  yearPickerHeaderAriaLabel: string;
}

export interface CurrencyStrings {
  EUR: string;
  CZK: string;
}

const translations: Record<string, DatePickerStrings> = {
  "cs-CZ": {
    months: [
      "Leden",
      "Únor",
      "Březen",
      "Duben",
      "Květen",
      "Červen",
      "Červenec",
      "Srpen",
      "Září",
      "Říjen",
      "Listopad",
      "Prosinec",
    ],
    shortMonths: [
      "Led",
      "Úno",
      "Bře",
      "Dub",
      "Kvě",
      "Čvn",
      "Čvc",
      "Srp",
      "Zář",
      "Říj",
      "Lis",
      "Pro",
    ],
    days: [
      "Neděle",
      "Pondělí",
      "Úterý",
      "Středa",
      "Čtvrtek",
      "Pátek",
      "Sobota",
    ],
    shortDays: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
    goToToday: "Přejít na dnešek",
    prevMonthAriaLabel: "Předchozí měsíc",
    nextMonthAriaLabel: "Další měsíc",
    prevYearAriaLabel: "Předchozí rok",
    nextYearAriaLabel: "Další rok",
    closeButtonAriaLabel: "Zavřít",
    monthPickerHeaderAriaLabel: "{0}, vybrat pro změnu roku",
    yearPickerHeaderAriaLabel: "{0}, vybrat pro změnu měsíce",
  },
  "en-GB": {
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    days: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    goToToday: "Go to today",
    prevMonthAriaLabel: "Previous month",
    nextMonthAriaLabel: "Next month",
    prevYearAriaLabel: "Previous year",
    nextYearAriaLabel: "Next year",
    closeButtonAriaLabel: "Close",
    monthPickerHeaderAriaLabel: "{0}, select to change the year",
    yearPickerHeaderAriaLabel: "{0}, select to change the month",
  },
};

const currencyTranslations: Record<string, CurrencyStrings> = {
  "cs-CZ": {
    EUR: "Euro",
    CZK: "Česká koruna",
  },
  "en-GB": {
    EUR: "Euro",
    CZK: "Czech Koruna",
  },
};

export const useLocalization = (language: string = "cs"): DatePickerStrings => {
  return useMemo(() => {
    return translations[language] || translations["cs-CZ"];
  }, [language]);
};

export const useCurrencyLocalization = (
  language: string = "cs-CZ"
): CurrencyStrings => {
  return useMemo(() => {
    return currencyTranslations[language] || currencyTranslations["cs-CZ"];
  }, [language]);
};
